import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Pagination from '@material-ui/lab/Pagination';
import { SelectBox } from 'devextreme-react/select-box';
import { IconButton } from '@material-ui/core';
import SyncIcon from '@material-ui/icons/Sync'


const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    margin: 15,
    marginBottom: 20
  },
  icon: {
    color: "#3B5158"
  }
}));

export default function CustomPagination(props) {
  const { totalPages, updateAction, loading } = props;
  const classes = useStyles();
  const dataSource = props.numElements ? props.numElements : [15, 50, 100];


  return (
    <div className={classes.root}>
    <span style={{marginRight: 5, fontSize: 12}}>No. filas</span>
    <span style={{marginRight: 5}}><SelectBox disabled={loading !== "succeeded"} dataSource={dataSource} value={props.pageSize} style={{width: 75}} onValueChange={props.handlePageSizeChange}/> </span>
    <span style={{ fontSize: 12}}> {props.count} resultados</span>
    <span style={{flexGrow: 1}}><IconButton onClick={props.refreshPage} title={"Refrescar tabla"}><SyncIcon classes={{root: classes.icon}} /></IconButton></span>
    <Pagination page={props.pageIndex} disabled={loading !== "succeeded"} count={totalPages} shape="rounded" onChange={props.handlePageIndexChange} />
    </div>
  );
}